import { UtilityBannerProps } from '@grubhubprod/gh-cookbook-react';
import { BalanceBannerType } from 'src/components/selfService/common/Balance/balance.types';

export interface CreditLimitBannerParams {
  usagePercent: number;
}

const bannerConfigMap = {
  [BalanceBannerType.CreditLimitApproaching]: (
    params: CreditLimitBannerParams
  ): UtilityBannerProps => ({
    header: "You're approaching your corporate credit limit",
    message: `Your company has used ${params.usagePercent}% of its approved credit amount. If the credit limit is reached, employees may be temporarily unable to use their meal credits at checkout. Please visit your Balance portal to manage your account.`,
    flavor: 'info',
  }),
  [BalanceBannerType.ServiceUnavailable]: {
    header: 'Meal credits are temporarily unavailable',
    message:
      "Balance is having technical issues. Employees can still order using alternate payment methods. We'll notify you when service is restored.",
    flavor: 'info',
  },
  [BalanceBannerType.SuspendedGeneric]: {
    header: 'Account suspended',
    message:
      'Your corporate account has been temporarily restricted, and all meal credit(s) are currently unavailable for new orders. Please visit the Balance portal to review your account status and learn what action is needed to reinstate full service.',
    flavor: 'error',
  },
  [BalanceBannerType.SuspendedInvoices]: {
    header: 'Account suspended: Invoices due',
    message:
      'Your corporate account has been temporarily restricted, and all meal credit(s) are currently unavailable for new orders. Please visit the Balance portal to review your account status and take action to reinstate full service.',
    flavor: 'error',
  },
  [BalanceBannerType.SuspendedSecurity]: {
    header: 'Account suspended: Security review',
    message:
      'Your corporate account has been temporarily restricted due to activity that violates our security policy. All meal credit usage is unavailable while our team investigates. Please contact Balance Support at support@getbalance.com to discuss your account status and the next steps for reinstatement.',
    flavor: 'error',
  },
} as const;

export function getBalanceStatusBanner(
  type: BalanceBannerType.CreditLimitApproaching,
  params: CreditLimitBannerParams
): UtilityBannerProps;
export function getBalanceStatusBanner(
  type: Exclude<BalanceBannerType, BalanceBannerType.CreditLimitApproaching>
): UtilityBannerProps;
export function getBalanceStatusBanner(
  type: BalanceBannerType,
  params?: CreditLimitBannerParams
): UtilityBannerProps {
  const configOrFactory = bannerConfigMap[type];
  return typeof configOrFactory === 'function'
    ? configOrFactory(params)
    : configOrFactory;
}
